import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/34_christmas_tree/34_christmas_tree"
 * Contains 1 texture(s)
 */
export class Desktop34ChristmasTreeAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/34_christmas_tree/34_christmas_tree';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '34_christmas_tree.png'
    ] as const;
}
